import { PinMap } from '@awaze/design-system.components.icon';
import { Prose, Text } from '@awaze/design-system.components.text';
import { pxToRems } from '@awaze/design-system.utils.react';
import styled from 'styled-components';
import { onDesktop, onMobile } from './search-form-composition.styles';
export const PinMapAdjust = styled(PinMap) `
  & > div {
    height: 100% !important;
  }
`;
export const StyledNoResults = styled(Prose) `
  padding-top: ${pxToRems(8)};

  ${onDesktop} {
    padding-top: 0;
  }
`;
export const StyledWideAutocompleteContainer = styled.div `
  display: flex;
  &:focus-within {
    z-index: 1;
  }

  flex: 2 !important;

  ${onMobile} {
    display: none;
  }

  > span {
    height: 100%;
    display: flex;
    width: 100%;

    > div {
      height: 100%;
      display: flex;
      align-items: center;
      width: 100%;

      &:first-child {
        width: 100%;
      }
    }
  }

  input {
    border: 2px solid transparent;
    margin: 0;

    &:hover {
      border-color: transparent;
    }

    &:active,
    &:focus {
      outline: 2px solid
        ${({ theme }) => theme.ColorComponentSearchBarBorderActive};
      box-shadow: none;
      border-color: transparent;
    }
  }
`;
export const StyledTextLegacyAccordionHeader = styled(Text) `
  margin-top: ${pxToRems(14)};
`;
export const StyledDrawerBody = styled.div `
  margin: 0 ${pxToRems(24)} ${pxToRems(24)};
`;
export const StyledDriveTimeSelector = styled.button `
  color: inherit;
  display: grid;
  grid-template-columns: 24px auto 24px;
  grid-template-rows: auto auto;
  gap: 8px;
  border-radius: 4px !important;
  padding: 8px 12px;
  border: solid 1px ${({ theme }) => theme.ColorInputDefaultOutline} !important;
  background-color: ${({ theme }) => theme.ColorGrey50};
  justify-items: start;
  text-align: left;
  align-items: center;
  width: 100%;
  cursor: pointer;

  p {
    grid-column: 1 / span 2;
    font-size: 12px;
    margin: 0;
    max-width: 34ch;
  }
`;
export const StylesDriveTimeWarning = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.ColorStatusCaution25};
  padding: 8px 12px;
  gap: 8px;
  margin-top: 8px;

  span {
    font-size: 14px;
  }
`;
//# sourceMappingURL=destination-select.styles.js.map